import { createFileRoute } from "@tanstack/react-router";
import { Index } from "@/components/home/HomePage";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

export const Route = createFileRoute("/fi/")({
  loader: async ({ context }) => {
    const settings = await context.queryClient.fetchQuery({
      queryKey: ["public-site-settings"],
      queryFn: async () => {
        const { supabase } = await import("@/integrations/supabase/client");
        const { data, error } = await supabase.from("site_settings").select("key, value");
        if (error) throw error;
        const obj: any = {};
        for (const row of data ?? []) obj[(row as any).key] = (row as any).value;
        return obj;
      },
    });
    return { hero_images: Array.isArray(settings?.hero_images) ? settings.hero_images : [] };
  },
  head: () => ({
    meta: [
      { title: "Helsinki-opas: Ravintolat, Saunat & Tapahtumat | what Finland" },
      { name: "description", content: "Käsin koottu Helsinki- ja Suomi-opas — parhaat ravintolat, saunat, saaristoretket, designkävelyt, livetapahtumat ja liput Helsingissä, Turussa ja Tampereella." },
      { property: "og:title", content: "Helsinki-opas: Ravintolat, Saunat & Tapahtumat | what Finland" },
      { property: "og:description", content: "Käsin koottu Helsinki- ja Suomi-opas paikallisilta." },
      { property: "og:url", content: "https://whatfinland.com/fi" },
      ...buildLocaleMeta("fi"),
    ],
    links: [
      { rel: "canonical", href: "https://whatfinland.com/fi" },
      ...buildHreflangLinks("/fi"),
    ],
  }),
  component: Index,
});
